import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { FlowNode } from '../../../types/flowBuilder';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

const MissingItemsQueryNode: React.FC<NodeProps<FlowNode['data']>> = ({ data, selected }) => {
  const statusFilter = data.config?.statusFilter || 'all';
  const includeCompleted = data.config?.includeCompleted || false;

  return (
    <div className={`px-4 py-3 shadow-lg rounded-lg bg-gradient-to-r from-orange-400 to-orange-500 border-2 transition-all duration-200 ${
      selected ? 'border-orange-600 shadow-xl scale-105' : 'border-orange-300'
    }`}>
      <div className="flex items-center space-x-3">
        {/* Icon */}
        <div className="flex-shrink-0">
          <div className="w-8 h-8 bg-white bg-opacity-20 rounded-lg flex items-center justify-center">
            <ExclamationTriangleIcon className="w-5 h-5 text-white" />
          </div>
        </div>

        {/* Content */}
        <div className="flex-1 min-w-0">
          <div className="text-sm font-semibold text-white truncate">
            {data.label}
          </div>
          {data.description && (
            <div className="text-xs text-orange-100 truncate mt-1">
              {data.description}
            </div>
          )}
          
          <div className="text-xs text-orange-100 mt-1">
            Hiányzó tételek lekérdezése
          </div>
        </div>

        {/* Status indicator */}
        <div className="flex-shrink-0">
          <div className={`w-3 h-3 rounded-full ${
            data.hasError ? 'bg-red-500' : 'bg-green-400'
          }`} />
        </div>
      </div>

      {/* Configuration preview */}
      {data.config && (
        <div className="mt-2 text-xs text-orange-100 bg-black bg-opacity-20 px-2 py-1 rounded">
          <div className="space-y-1">
            <div className="flex items-center space-x-2">
              <span className="w-2 h-2 bg-orange-200 rounded-full" />
              <span className="truncate">
                Státusz: {statusFilter === 'all' ? 'Összes' : statusFilter}
              </span>
            </div>
            {includeCompleted && (
              <div className="flex items-center space-x-2">
                <span className="w-2 h-2 bg-orange-200 rounded-full" />
                <span className="truncate">
                  Teljesített is: ✓
                </span>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Error message */}
      {data.hasError && data.errorMessage && (
        <div className="mt-2 text-xs text-red-200 bg-red-500 bg-opacity-20 px-2 py-1 rounded">
          {data.errorMessage}
        </div>
      )}

      {/* Execution result */}
      {data.executionData && (
        <div className="mt-2 text-xs bg-black bg-opacity-30 px-2 py-1 rounded">
          <div className="text-orange-100 font-semibold">
            📦 {data.executionData.count || 0} hiányzó tétel
          </div>
        </div>
      )}

      {/* Input handle */}
      <Handle
        type="target"
        position={Position.Left}
        id="input"
        className="w-3 h-3 bg-white border-2 border-orange-500"
        style={{ left: -6 }}
      />

      {/* Output handle */}
      <Handle
        type="source"
        position={Position.Right}
        id="output"
        className="w-3 h-3 bg-white border-2 border-orange-500"
        style={{ right: -6 }}
      />
    </div>
  );
};

export default MissingItemsQueryNode;
